import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import {reExportedColors} from '../1elements'

const SubTabsBase = ({menuItems, selectedTabIndex, setSelectedTabIndex, listItemIcon, primaryTypographyProps}) => {
    const switchTab = (index) => {
        setSelectedTabIndex(index)
    }

    return (
        <List sx={{ alignItems: 'stretch', display: 'flex', flexDirection: 'column', width: '100%' }} component="nav" aria-label="main mailbox folders">
            {menuItems.map((menuItem, index) => {
                const tabValue = menuItem.value ?? index

                return (
                    <ListItemButton
                        key={tabValue}
                        onClick={() => switchTab(tabValue)}
                        sx={{
                            backgroundColor: tabValue === selectedTabIndex ? reExportedColors.LIGHT_GREY : undefined,
                            borderBottom: `2px solid ${reExportedColors.LIGHT_GREY}`,
                            minHeight: '48px',
                            width: '100%'
                        }}
                    >
                        {listItemIcon && listItemIcon}
                        <ListItemText
                            primary={menuItem.label}
                            primaryTypographyProps={primaryTypographyProps}
                            secondary={menuItem.description}
                        />
                    </ListItemButton>
                )
            })}
        </List>
    )
}

export default SubTabsBase
